import { render, staticRenderFns } from "./OrgHomeIntakeStats.vue?vue&type=template&id=1e4da858&scoped=true&"
import script from "./OrgHomeIntakeStats.vue?vue&type=script&lang=js&"
export * from "./OrgHomeIntakeStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4da858",
  null
  
)

export default component.exports